import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import projects from './projects-list.json';
import './ProjectViewer.css';

const ProjectViewer = () => {
  const { id } = useParams();
  const project = projects.find(p => p.id === id);

  if (!project) {
    return <div className="platform-page"><p>Project not found</p></div>;
  }

  return (
    <>
      <Helmet>
        <title>{project.title} - Victor Barbarosh</title>
        <meta name="description" content={project.briefSummary} />
      </Helmet>
      
      <div className="platform-page project-viewer">
        <Link to="/projects" className="home-link top">← Back to Projects</Link>

        <header className="project-header">
          {project.logo && (
            <img src={project.logo} alt={project.title} className="project-logo-large" />
          )}
          <h1>{project.title}</h1>
          <div className="project-meta">
            <span className={`category-badge ${project.status}`}>{project.status}</span>
            <time>Completed: {new Date(project.dateCompleted).toLocaleDateString()}</time>
          </div>
        </header>

        <div className="tech-tags">
          {project.technologies.map(tech => (
            <span key={tech} className="tech-tag">{tech}</span>
          ))}
        </div>

        <div className="project-description">
          {project.description.split('\n').map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>

        {project.links && (
          <div className="project-links">
            <h3>Get the Extension</h3>
            {project.links.chrome && (
              <a href={project.links.chrome} target="_blank" rel="noopener noreferrer" className="store-link chrome">
                Chrome Web Store
              </a>
            )}
            {project.links.edge && (
              <a href={project.links.edge} target="_blank" rel="noopener noreferrer" className="store-link edge">
                Microsoft Edge Add-ons
              </a>
            )}
          </div>
        )}

        <Link to="/projects" className="home-link bottom">← Back to Projects</Link>
      </div>
    </>
  );
};

export default ProjectViewer;
